<template>
  <div>
   <div v-if="spinner">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
   </div>
   <div v-else>   
      
      
      <h4   style="color: blue;" class="font-weight-bolder">
       
        [ID PRODOTTO {{product.productId}}] -  {{product.sku}} - {{product.brand}} - {{product.category}}  {{product.department}} - {{product.material}} - {{product.season}}  {{product.season_year}}</h4>
   </div>
  </div>
</template>

<script>

import api from '@/api'
  export default {
     props: ['productId'],
     components: {},
    data () {
      return {
        
         product     : {},
         spinner     : false
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
      
      
    },
    mounted()
    {   
     
    },
    created () 
    {
      if(this.productId)
      {
        this.getData()
      }
    },
    methods: 
    {
        
      async getData()
      {
        this.spinner  = true
        var data      = {'productId' : this.productId}
        var sp        = {'sp' : 'spProductData'}
        var json      = Object.assign(data, sp);

        await api.post(json).then(res => {
     

          if(res.status==200)
            {
               this.product = res.data.recordsets[0][0] 
            }
           else if(res.status==500)
           {
                console.log(res.data)                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
              this.spinner = false
        });
        

          
      },
          

    }
  }
</script>
<style scoped>

h4 
{
  font-family: 'Roboto Condensed';
  font-size: 20px;
};

</style>
